<template>
    <div class="container">

        <div class="row">
            <div class="col-md-6" v-for="aVideo in videoList" :key="aVideo.id">
                <div class="card mb-3">
                    <div class="row g-0">
                        <div class="col-md-6">
                            <div class="card-body">
                                <div class="observations" v-html="aVideo.observations"></div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="embed-responsive embed-responsive-16by9">
                                <iframe :id="'video'+ aVideo.id" :src="convertToEmbedUrl(aVideo.videourl)"
                                    frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import EventBus from '../../event-bus';
import Editor from '@tinymce/tinymce-vue';
// import { v4 as uuidv4 } from 'uuid';

export default {
    components: {
        vObservations: Editor,
        // videoObservations2: Editor,
     },
    name: "UserVideoSetup",
    data() {
        return {
            csrf_token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            userinfo:'',
            currentVideo: '',
            videourl:'',
            videoList:'',
            currentVideoid: '',
            currentVideoname:'',
            currentVideodescription: '',
            currentVideovideourl: '',
            currentVideoobservations: '',
            currentVideoobservationsxx: 'xyz xyz'
        }
    },

    props: {
        userdata:'',
        videos:'',
        apikey:'',
    },
    mounted() {
            this.userinfo = JSON.parse(this.userdata);
            this.videoList = JSON.parse(this.videos);

        //Helps overcome Bootstrap blocking of the Image input:
        // $(document).on('focusin', function(e) {
        //     if ($(e.target).closest(".tox-tinymce, .tox-tinymce-aux, .moxman-window, .tam-assetmanager-root").length) {
        //         e.stopImmediatePropagation();
        //     }
        //     });
    },


    methods: {
        loadVideo() {
            if(this.currentVideoid != '')  {
                console.error("Loading video: " + this.currentVideoid);
                var selVideo = this.getVideo(this.currentVideoid);
                this.currentVideoname = selVideo.name;
                this.currentVideodescription = selVideo.description;
                this.currentVideovideourl = selVideo.videourl;
                this.currentVideoobservations = selVideo.observations;
            } else {
                console.error("Loading video: " + this.currentVideoid);
                this.currentVideoname = '';
                this.currentVideodescription =  '';
                this.currentVideovideourl = '';
                this.currentVideoobservations =  '';
            }
        },
        // convertToEmbedUrl(youtubeUrl) {
        //     // Extract the video ID using a regular expression
        //     const match = youtubeUrl.match(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
        //     if (match && match[1]) {
        //         // Build the embed URL with the extracted video ID
        //         const embedUrl = `https://www.youtube.com/embed/${match[1]}`;
        //         return embedUrl;
        //     } else {
        //         // Handle invalid or unsupported URL formats
        //         console.error('Invalid YouTube URL:', youtubeUrl);
        //         this.updateToast('Invalid YouTube URL:'+ youtubeUrl, 4000, 'error');
        //         return null;
        //     }
        // },
// convertToEmbedUrl(youtubeUrl) {
//   // Regular expression to match YouTube URLs with and without cookies
//   const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

//   // Extract the video ID using the regular expression
//   const match = youtubeUrl.match(regex);

//   if (match && match[1]) {
//     // Build the embed URL with the extracted video ID
//     const embedUrl = `https://www.youtube.com/embed/${match[1]}`;
//     return embedUrl;
//   } else {
//     // Handle invalid or unsupported URL formats
//     console.error('Invalid YouTube URL:', youtubeUrl);
//     return null;
//   }
// },
convertToEmbedUrl(videoUrl) {
  // Regular expressions to match YouTube and Vimeo URLs
  const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const vimeoRegex = /(?:https?:\/\/)?(?:www\.)?(?:player\.)?vimeo\.com\/(?:video\/)?(\d+)/;

  // Check if the URL is a YouTube URL
  const youtubeMatch = videoUrl.match(youtubeRegex);
  if (youtubeMatch && youtubeMatch[1]) {
    // Build the YouTube embed URL with the extracted video ID
    return `https://www.youtube.com/embed/${youtubeMatch[1]}`;
  }

  // Check if the URL is a Vimeo URL
  const vimeoMatch = videoUrl.match(vimeoRegex);
  if (vimeoMatch && vimeoMatch[1]) {
    // Return the Vimeo URL unchanged
    return videoUrl;
  }

  // If the URL is not recognized as YouTube or Vimeo, return it unchanged
  return videoUrl;
},
        getVideo(videoid) {
            var theVideo= '';
            [...this.videoList].forEach(aVideo=>{
                if(aVideo.id == videoid) theVideo = aVideo;
            });
            return theVideo;
        },
        currentVideoSaveable() {
            return this.currentVideoname != '' && this.currentVideodescription != '' && this.currentVideovideourl != '';
        },

        modalReset() {
            //set all fields to blank
            this.videodata.id = '';
            this.videodata.name = '';
            this.videodata.description = '';
            this.videodata.videourl = '';
        },
        getInitMenuPlugins() {
            return {
                height: 200,
                menubar: false,
                link_context_toolbar: true,
                image_class_list: [
                    {title: 'Responsive', value: 'img-responsive'}
                ],
                plugins: 'code table lists image',
                toolbar: 'undo redo | formatselect| bold italic | alignleft aligncenter alignright | indent outdent | bullist numlist | link | image code | table'
            }
        },
        // getInitMenuPlugins() {
        //     return {
        //         height: 200,
        //         menubar: false,
        //         plugins: [
        //             'code table lists'
        //         ],
        //         toolbar:
        //             'undo redo | formatselect | bold italic backcolor | \
        //             alignleft aligncenter alignright alignjustify | \
        //             bullist numlist outdent indent | removeformat | help'
        //     }
        // },
        preventBootstrap() {
            // Prevent Bootstrap dialog from blocking focusin
            $(document).on('focusin', function(e) {
            if ($(e.target).closest(".tox-tinymce, .tox-tinymce-aux, .moxman-window, .tam-assetmanager-root").length) {
                e.stopImmediatePropagation();
            }
            });
        },

        saveAction() {
            this.saveDetails();
        },
        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },
        cancel() {
            // EventBus.$emit('refreshLessonParent');
            $('div#edit-lesson-modal').modal('hide');
        },
    },
    computed: {
    },
}
</script>
<style>
.bg-custom{
    background: #449acb;
color: #fff;
}

.video-container {
  position: relative;
  width: 50%; /* Adjust as needed */
  height: auto; /* Adjust as needed */
  max-width: 800px; /* Optional: Set a maximum width */
  margin: 0 auto; /* Optional: Center the video */
}
</style>
